import React from 'react'
import css from './checkBox.css'
type Props = {
  label?: string
  name?: string
  value?: string | number | boolean
  checked?: boolean
  onChange?: (...args: Array<any>) => any
  disabled?: boolean
}

const CheckBox = ({ label, checked, value, name, onChange, disabled }: Props) => {
  const inputProps: any = {
    value,
    name,
    onChange,
    checked,
    disabled,
  }

  if (checked) {
    inputProps.defaultChecked = true
  }

  return (
    <div className={css.component}>
      <label>
        <input type='checkbox' {...inputProps} />
        <div className={css.check} />
        {label && <span className={css.label}>{label}</span>}
      </label>
    </div>
  )
}

export default CheckBox
